import { TabsProps, TabProps } from '@procore/core-react/dist/_typedoc/Tabs/Tabs.types.json';
import * as React from 'react';
export default {
  TabsProps,
  TabProps,
  React
};